export type BasicData = {
  lastName: string
  firstName: string
  lastNameFurigana: string
  firstNameFurigana: string
  birthYear: string | number
  birthMonth: string | number
  birthDay: string | number
  age: string | number
  sex: string
  postNumber: string
  address1: string
  address2: string
  addressFurigana: string
  tel1: string
  tel2: string
  tel3: string
  email: string
  idPhotoSrc: string
  useContact: string | string[]
  contactPostNumber: string
  contactAddress1: string
  contactAddress2: string
  contactAddressFurigana: string
  contactCareOf: string
  contactTel1: string
  contactTel2: string
  contactTel3: string
  contactMobile: string
  contactFax: string
  contactEmail: string
  yakushokuBusho: string
  gyoushuCd: string
  shokushuCd: string
  kibouGyoushuCd: string
  kibouShokushuCd: string
  updateDate: string
  hopeAreaPref: string
  department_name: string
}

export function createEmptyBasicData(): BasicData {
  return {
    lastName: '',
    firstName: '',
    lastNameFurigana: '',
    firstNameFurigana: '',
    birthYear: '',
    birthMonth: '',
    birthDay: '',
    age: '',
    sex: '',
    postNumber: '',
    address1: '',
    address2: '',
    addressFurigana: '',
    tel1: '',
    tel2: '',
    tel3: '',
    email: '',
    idPhotoSrc: '',
    useContact: '',
    contactPostNumber: '',
    contactAddress1: '',
    contactAddress2: '',
    contactAddressFurigana: '',
    contactCareOf: '',
    contactTel1: '',
    contactTel2: '',
    contactTel3: '',
    contactMobile: '',
    contactFax: '',
    contactEmail: '',
    yakushokuBusho: '',
    gyoushuCd: '',
    shokushuCd: '',
    kibouGyoushuCd: '',
    kibouShokushuCd: '',
    updateDate: '',
    hopeAreaPref: '',
    department_name: ''
  }
}

export function needsField(
  requiredBasicFields: string[] | undefined,
  name: string
): boolean {
  if (!requiredBasicFields || requiredBasicFields[0] === 'all') return true
  return requiredBasicFields.indexOf(name) > -1
}

export function calcLastDay(
  birthYear: string | number,
  birthMonth: string | number
): number {
  if (!birthYear || !birthMonth) return 31
  try {
    const ym = new Date(Number(birthYear), Number(birthMonth), 0)
    return ym ? ym.getDate() : 31
  } catch (e) {
    console.error(e)
    return 31
  }
}

export function isMobileUa(): boolean {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
}

export function pathFormatId(): string {
  return window.location.pathname.split('/')[2] || ''
}

export function expectedDocumentType(formatId: string): string {
  const fmtId = formatId || pathFormatId()
  if (
    fmtId &&
    (fmtId.includes('shokumukeirekisho') || fmtId.includes('skillsheet'))
  ) {
    return 'shokumukeirekisho'
  }
  return 'rirekisho'
}

export function isBirthDateFilled(
  year?: number | string | null,
  month?: number | string | null,
  day?: number | string | null
): boolean {
  return Boolean(year) && Boolean(month) && Boolean(day)
}

export function calcAgeFromBirth(
  birthYear: string | number,
  birthMonth: string | number,
  birthDay: string | number
): number | ' ' {
  if (!isBirthDateFilled(birthYear, birthMonth, birthDay)) return ' '
  const birthDate = new Date(
    Number(birthYear),
    Number(birthMonth) - 1,
    Number(birthDay)
  )
  const createDate = new Date()
  const diff = new Date(createDate.getTime() - birthDate.getTime())
  const result = Math.abs(diff.getUTCFullYear() - 1970)
  if (isNaN(result)) return ' '
  return result
}
